import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container mx-auto" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", {
  class: "text-center font-extrabold mb-6",
  style: {"font-size":"32px"}
}, " TIMELAPSE 2022 ", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "flex justify-center px-4" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "/images/our-forest/Video.webp",
    alt: ""
  })
], -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

import { defineComponent } from 'vue';

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

defineComponent({
  name: 'ForestTimelapse',
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_4))
}
}

})